import React from 'react';
import OnboardingApp from './OnboardingApp';
 
function App() {
  return <OnboardingApp />;
}
 
export default App;